import script from "./CustomListButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListButton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListButton.vue?vue&type=style&index=0&id=0311bd56&lang=less"

const __exports__ = script;

export default __exports__